import type {ReactNode} from 'react';

import {createView, view} from '@sail/ui';

type Props = {
  children?: ReactNode;
};

export const ThreadsContainer = createView(({children, ...props}: Props) => {
  return (
    <view.div
      data-testid="threads-container"
      css={{
        position: 'relative',
        overflow: 'hidden',
        stack: 'y',
        height: 'fill',
        backgroundColor: 'white',
      }}
      {...props}
    >
      {children}
    </view.div>
  );
});
